import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ReadUserReferralsRequestDto,
  ReadUserReferralsResponseDto,
  UserIntroducerRequestDto,
  UserIntroducerResponseDto,
} from '@sparling/financial-common'

export const {
  request: requestIntroducerRequest,
  success: requestIntroducerSuccess,
  failure: requestIntroducerFailure,
} = createAsyncAction('REQUEST_INTRODUCER_REQUEST', 'REQUEST_INTRODUCER_SUCCESS', 'REQUEST_INTRODUCER_FAILURE')<
  UserIntroducerRequestDto & { token: string },
  UserIntroducerResponseDto,
  Error
>()

export const requestIntroducerCanUpdateUserDetails = createAction(
  'REQUEST_INTRODUCER_CAN_UPDATE_USER_DETAILS',
)<boolean>()

export const {
  request: getReferralsRequest,
  success: getReferralsSuccess,
  failure: getReferralsFailure,
} = createAsyncAction('GET_REFERRALS_REQUEST', 'GET_REFERRALS_SUCCESS', 'GET_REFERRALS_FAILURE')<
  ReadUserReferralsRequestDto & { token: string },
  ReadUserReferralsResponseDto,
  Error
>()
